export const PlatformRootUrl = process.env.REACT_APP_CEREBRO_PLATFORM_ROOT_URL ?? '';
export const EmployeeAppRootUrl = process.env.REACT_APP_CEREBRO_EMPLOYEE_APP_ROOT_URL ?? '';
export const LoanApplicationUrl = process.env.REACT_APP_CEREBRO_LOAN_APPLICATION_ROOT_URL ?? '';
export const LenderAppRootUrl = process.env.REACT_APP_CEREBRO_LENDER_APP_ROOT_URL ?? '';
export const MaxCurrencyLength = 15;

export const RedirectToPlatform = () => {
	globalThis.location.href = `${PlatformRootUrl}?returnUrl=${encodeURIComponent(globalThis.location.href)}`;
};

export const GetLogoutUrl = () => `${PlatformRootUrl}/Account/LogOut`;
